import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    week: '7 days',
    month: '1 month',
    sixMonths: '6 months',
    year: '1 year',
  },
};
